<div class="template">
  <div class="div-error">
    <p>{{ 'ERRORS.NOTFOUND' | translate}}</p>
  </div>
</div>

